var map = {
	"./en/buyersHomepage": [
		68851,
		8851
	],
	"./en/buyersHomepage.json": [
		68851,
		8851
	],
	"./en/common": [
		28062,
		8062
	],
	"./en/common.json": [
		28062,
		8062
	],
	"./en/superadmin": [
		95261,
		5261
	],
	"./en/superadmin.json": [
		95261,
		5261
	],
	"./en/suppliersHomepage": [
		85982,
		5982
	],
	"./en/suppliersHomepage.json": [
		85982,
		5982
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 68091;
module.exports = webpackAsyncContext;